import React, { useEffect, Children } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import Home from "@material-ui/icons/Home";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import MenuBook from "@material-ui/icons/MenuBook";
import QuestionAnswer from "@material-ui/icons/QuestionAnswer";
import MailIcon from "@material-ui/icons/Mail";
import { NavLink, Link } from "react-router-dom";
import { Styles } from "../UI-Components";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import Smartphone from '@material-ui/icons/Smartphone';
import ListAlt from '@material-ui/icons/ListAlt';
import Description from '@material-ui/icons/Description';
import PersonPin from '@material-ui/icons/PersonPin';
import {withRouter} from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import "./sideNav.css"; 
import { Image } from 'react-native';
import { connect} from 'react-redux';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

// import { Login } from '@material-ui/icons/login';

const logo = require('./../../assets/avatar.jpeg');
const homeIcon = require('./../../assets/assets_png/HomeActive.png');
const courseActive = require('./../../assets/assets_png/courseA.png');
const courseInActive = require('./../../assets/assets_png/courseIn.png');
const testSeriesActive = require('./../../assets/assets_png/testSeriesActive.png');
const testSeriesInactive = require('./../../assets/assets_png/testSeriesInActive.png');
const libraryActive = require('./../../assets/assets_png/libraryActive.png');
const libraryInActive = require('./../../assets/assets_png/libraryInActive.png');

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  paper: {
    background: '#f9c741'
  }
});

const routesForExamNation = ["/changePhoneNumber", '/aboutUs', '/disclaimer', "/termsAndCondition", "/editProfile"]


const SideNav = ({ openDrawer, closeDrawer, children, props })  => {
  
  const { homeData } = props;
  const {user_details={}} = homeData || []
  const { username, profile_pic } = user_details || {}

  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
    subMenu: false
  });
 
  const [subMenu, setOpen] = React.useState(false);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return null;
    }

    setState({ ...state, [anchor]: open });
    typeof closeDrawer === "function" && closeDrawer(open);

  };

  useEffect(() => {
    // console.log(props.match)
    if (openDrawer) {
      setState({ ...state, left: true });
    }
    if(props.homeData){
      console.log(props.homeData,'homeData')
    }

    
   
  }, [openDrawer]);

  const list = (anchor) => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
          <ListItem button className="bg_clr" key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem button className="bg_clr" key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <div >
      {["left"].map((anchor) => (
        <div key={anchor} style={{backgroundColor: '#f9c741'}}>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            classes={{ paper: classes.paper }}
         
          >

          <List  style={{paddingTop:20,paddingBottom:0, backgroundColor: '#f9c741'}}>
            <Card style={{ borderRadius: 0,boxShadow:'none',  backgroundColor: '#f9c741'}}>
              <CardContent style={{ marginLeft: 15, justifyContent: 'flex-start', alignItems: 'center', 
              display: 'flex', flexDirection: 'row' ,padding:0, marginBottom: 10}}>
                <div style={{width:80, height: 80, borderRadius: '100%', border: '2px solid #fff'}}>
                  <Image source={profile_pic ? {uri: profile_pic} : {uri: 'https://secureservercdn.net/198.12.144.78/rph.2dc.myftpupload.com/wp-content/uploads/2020/09/site-logo.png'}} style={{width: '100%', height: '100%', borderRadius: '100%', objectFit: 'center' }}/>
                </div>
                {/* <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" /> */}
                <div style={{flexDirection: 'column', marginLeft: 20,maxWidth: 300, flexWrap: 'wrap', overflow: 'hidden',  }}>
                <Typography variant='h6' style={{fontSize:18, fontWeight: 'bold' }}>Hello,</Typography>
                <Typography variant='h6' style={{fontSize:18, fontWeight: 'bold', }}
                 noWrap={true}
                >
                  {username}
                </Typography>
                </div>
              </CardContent>
            </Card>
          </List>
            <NavLink
              exact={true}
              activeClassName="is-active"
              activeStyle={{
                
                color: '#000',
                backgroundColor: Styles.sideNavColor,
              }}
              to={"/Home"}
              style={{
                color: "#000",
                textDecoration: "none",
                fontWeight: "bold",
                fontWeight: 16,
                minWidth: 270,
                paddingTop: 10
              }}
              title="Home"
            >
              <ListItem button className="bg_clr">
                <ListItemIcon className="icon_clr">
                  {/* <img src={homeIcon}/> */}
                  <Home/>
                </ListItemIcon>
                <ListItemText className="profile_text" primary={"Home"} />
              </ListItem>
            </NavLink>

            <NavLink
              exact={true}
              activeClassName="is-active"
              activeStyle={{
                fontWeight: "bold",
                fontWeight: 16,
                color: '#000',
                backgroundColor: Styles.sideNavColor,
              }}
              to={"/MyTests"}
              style={{
                color: "#000",
                textDecoration: "none",
                fontWeight: 'bold',
              }}
              title="My Tests"
            >
              <ListItem button className="bg_clr">
                <ListItemIcon className="icon_clr">
                  <QuestionAnswer />
                  {/* <img src={testSeriesActive}/> */}
                </ListItemIcon>
                <ListItemText
                  className="profile_text"
                  primary={"My Tests"}
                />
              </ListItem>
            </NavLink>
            <NavLink
              exact={true}
              activeClassName="is-active"
              activeStyle={{
                fontWeight: "bold",
                fontWeight: 16,
                color: '#000',
                backgroundColor: Styles.sideNavColor,
              }}
              to={"/video"}
              style={{
                color: "#000",
                textDecoration: "none",
                fontWeight: 'bold',
              }}
              title="Zoom"
            >
              <ListItem button className="bg_clr">
                <ListItemIcon className="icon_clr">
                  <QuestionAnswer />
                  {/* <img src={testSeriesActive}/> */}
                </ListItemIcon>
                <ListItemText
                  className="profile_text"
                  primary={"Zoom"}
                />
              </ListItem>
            </NavLink>

            <NavLink
              exact={true}
              activeClassName="is-active"
              activeStyle={{
                fontWeight: "bold",
                fontWeight: 16,
                color: '#000',
                backgroundColor: Styles.sideNavColor,
              }}
              to={"/courseExam"}
              style={{
                color: "#000",
                textDecoration: "none",
                fontWeight: 'bold',
              }}            >
              <ListItem button className="bg_clr">
                <ListItemIcon className="icon_clr">
                  <MenuBook />
                  {/* <img src={courseActive}/> */}
                </ListItemIcon>
                <ListItemText className="profile_text" primary={"My Courses"} />
              </ListItem>
            </NavLink>
            <NavLink
              exact={true}
              activeClassName="is-active"
              activeStyle={{
                fontWeight: "bold",
                fontWeight: 16,
                color: '#000',
                backgroundColor: Styles.sideNavColor,
              }}
              to={"/libraryExam"}
              style={{
                color: "#000",
                textDecoration: "none",
                fontWeight: 'bold',
              }}
              title="Library"
            >
              <ListItem button className="bg_clr">
                <ListItemIcon className="icon_clr">
                  <LibraryBooks />
                  {/* <img src={libraryActive}/> */}
                </ListItemIcon>
                <ListItemText className="profile_text" primary={"Library"} />
              </ListItem>
            </NavLink>
            <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color:'#000',
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/changePhoneNumber"}
                style={{
                  color: "#000",
                  textDecoration: "none",
                  fontWeight: 'bold',
                }}
                title="Change PhoneNumber"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <Smartphone />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"Change PhoneNumber"} />
                </ListItem>
              </NavLink>
            <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color:'#000',
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/editProfile"}
                style={{
                  color: "#000",
                  textDecoration: "none",
                  fontWeight: 'bold',
                }}
                title="Edit Profile"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <Smartphone />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"Edit Profile"} />
                </ListItem>
              </NavLink>
              {/* <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color: "#000",
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/chat"}
                style={{
                  color: "#000",
                  textDecoration: "none",
                }}
                title="Chat"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <ListAlt />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"Chat"} />
                </ListItem>
              </NavLink> */}
              <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color: "#000",
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/myFavourites"}
                style={{
                  color: "#000",
                  fontWeight: 'bold',
                  textDecoration: "none",
                }}
                title="My Favourites"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <ListAlt />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"My Favourites"} />
                </ListItem>
              </NavLink>
              <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color: "#000",
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/aboutUs"}
                style={{
                  color: "#000",
                  textDecoration: "none",
                  fontWeight: 'bold',
                }}
                title="About"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <ListAlt />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"About"} />
                </ListItem>
              </NavLink>
              <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color: '#000',
                  
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/disclaimer"}
                style={{
                  color: "#000",
                  textDecoration: "none",
                }}
                title="Disclaimer"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <Description />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"Disclaimer"} />
                </ListItem>
              </NavLink>
              <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color: '#000',
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/termsAndCondition"}
                style={{
                  color: "#000",
                  textDecoration: "none",
                  fontWeight: 'bold',
                }}
                title="TermsAndConditions"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <Description />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"TermsAndConditions"} />
                </ListItem>
              </NavLink>
              <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color: '#000',
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/contact"}
                style={{
                  color: "#000",
                  textDecoration: "none",
                  fontWeight: 'bold',
                }}
                title="Contact"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <Description />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"Contact"} />
                </ListItem>
              </NavLink>
          
              {/* <ListItem button className="bg_clr" onClick={() =>  setOpen(!subMenu)}>
                <ListItemIcon>
                  <InboxIcon />
                </ListItemIcon>
                <ListItemText primary="More" />
                {subMenu ? <ExpandLess /> : <ExpandMore />}
              </ListItem> */}
              {/* <Collapse in={subMenu}  style={{marginLeft: 6}}> */}
             
              {/* <NavLink
                exact={true}
                activeClassName="is-active"
                activeStyle={{
                  fontWeight: "bold",
                  fontWeight: 16,
                  color: '#000',
                  backgroundColor: Styles.sideNavColor,
                }}
                to={"/editProfile"}
                style={{
                  color: "#000",
                  textDecoration: "none",
                }}
                title="Edit Profile"
              >
                <ListItem button className="bg_clr">
                  <ListItemIcon className="icon_clr">
                    <PersonPin />
                  </ListItemIcon>
                  <ListItemText className="profile_text" primary={"Edit Profile"} />
                </ListItem>
              </NavLink> */}
              
              {/* </Collapse> */}
             <div  className='cursor-pointer'
              style={{display: 'flex',
               justifyContent: 'flex-start',
                alignItems:'center', 
                marginLeft: 15,
                position: 'fixed',
                bottom: 10,
                display:'flex',
                flexDirection: 'row',
              }}
              onClick={() => {
                setTimeout(() => {
                  props.history.push('/')
                  props.dispatchClearLogout();
                  props.logout();
                  props.dispatchClearHomeInfo(); 
                  props.dispatchClearCurrentAffairs(); 
                  props.dispatchClearRegistation();
                  props.dispatchClearOtp();
                }, 2000)
              } }
             >
               <ExitToAppIcon />
               <span style={{color: '#000', marginLeft:35, fontWeight: '700',}}>Logout</span>
             </div>
             <div style={{paddingTop: 10, paddingBottom: 20}}>

             </div>
          </Drawer>
        </div>
      ))}
    </div>
  );
}
export default (withRouter(SideNav));